//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscSecurity(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 2V4H19V10C19 14.81 17.03 17.76 12 20.38C6.97 17.76 5 14.81 5 10V6H3V10C3 17.46 7.63 20.43 12 22.62C16.38 20.43 21 17.46 21 10V2H3Z" fill="currentColor" /><path d="M15.29 7.78999L11.5 11.59L9.71004 9.78999L8.29004 11.21L11.5 14.41L16.71 9.20999L15.29 7.78999Z" fill="currentColor" /></svg>;
}
export default IconMiscSecurity;